function validate(values) {
  let errors = {};
  // if (!values.subject) {
  //   errors.subject = missingSubjectMessage;
  // }
  if (!values.terms) {
    errors.terms = "Please enter a search term";
  }
  return errors;
}

export { validate };
